module.exports = __webpack_public_path__ + "img/arrow_right.8ef6a08c.svg";